import { render, staticRenderFns } from "./chatHome.vue?vue&type=template&id=2d09bdcf&scoped=true"
import script from "./chatHome.vue?vue&type=script&lang=js"
export * from "./chatHome.vue?vue&type=script&lang=js"
import style0 from "./chatHome.vue?vue&type=style&index=0&id=2d09bdcf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d09bdcf",
  null
  
)

export default component.exports